export default __webpack_public_path__ + "static/media/Add.56df35e9.ico";